<div *ngIf="instantPayAvailability" class="ip-card" [ngClass]="{'ip-available': instantPayAvailability?.isAvailable}">

  <!-- ═══ AVAILABLE STATE ═══ -->
  <ng-container *ngIf="instantPayAvailability?.isAvailable">
    <div class="ip-avail-bg"></div>
    <div class="ip-avail-shine"></div>

    <div class="ip-avail-content">
      <div class="ip-bolt-wrap">
        <div class="ip-bolt-pulse"></div>
        <div class="ip-bolt-ring"></div>
        <div class="ip-bolt-icon">
          <i class="fas fa-bolt"></i>
        </div>
      </div>

      <div class="ip-avail-text">
        <span class="ip-avail-eyebrow">Instant Pay</span>
        <span class="ip-avail-headline">Available</span>
        <span class="ip-avail-hint">Use Early Pay on any eligible invoice</span>
      </div>
    </div>
  </ng-container>

  <!-- ═══ COUNTDOWN STATE ═══ -->
  <ng-container *ngIf="!instantPayAvailability?.isAvailable && timeDetails">
    <div class="ip-cd-bg"></div>
    <div class="ip-cd-noise"></div>

    <div class="ip-cd-content">
      <!-- Header Row -->
      <div class="ip-cd-header">
        <div class="ip-cd-badge">
          <i class="fas fa-clock"></i>
          <span>Instant Pay</span>
        </div>
      </div>

      <!-- Countdown Blocks -->
      <div class="ip-cd-grid">
        <div class="ip-cd-block">
          <span class="ip-cd-num">{{ timeDetails.days }}</span>
          <span class="ip-cd-unit">Days</span>
        </div>
        <span class="ip-cd-sep">:</span>
        <div class="ip-cd-block">
          <span class="ip-cd-num">{{ timeDetails.hours }}</span>
          <span class="ip-cd-unit">Hrs</span>
        </div>
        <span class="ip-cd-sep">:</span>
        <div class="ip-cd-block">
          <span class="ip-cd-num">{{ timeDetails.minutes }}</span>
          <span class="ip-cd-unit">Min</span>
        </div>
        <span class="ip-cd-sep ip-cd-sep--blink">:</span>
        <div class="ip-cd-block ip-cd-block--sec">
          <span class="ip-cd-num">{{ timeDetails.seconds }}</span>
          <span class="ip-cd-unit">Sec</span>
        </div>
      </div>

      <!-- Progress Bar -->
      <div class="ip-cd-progress">
        <div class="ip-cd-track">
          <div class="ip-cd-fill" [style.width.%]="progressPercent">
            <div class="ip-cd-dot"></div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

</div>
